import { FormField, FormData as ContactFormData, FormFiles } from '../types/ContactForm';

export const appendOrderedFieldValues = (
    submitData: globalThis.FormData,
    formFields: FormField[],
    formData: ContactFormData,
    files: FormFiles,
    shouldIncludeField?: (field: FormField) => boolean
): void => {
    formFields.forEach((field) => {
        if (shouldIncludeField && !shouldIncludeField(field)) {
            return;
        }

        if (field.type === 'file') {
            const fileOrFiles = files[field.name];
            if (!fileOrFiles) {
                return;
            }
            if (Array.isArray(fileOrFiles)) {
                fileOrFiles.forEach((file, index) => {
                    submitData.append(`${field.name}[${index}]`, file, file.name);
                });
            } else {
                submitData.append(field.name, fileOrFiles, fileOrFiles.name);
            }
            return;
        }

        if (!(field.name in formData)) {
            return;
        }

        submitData.append(field.name, formData[field.name]);
    });
};

export const getFieldsForStep = (
    formFields: FormField[],
    stepNumber: number
): Array<{ field: FormField; originalIndex: number }> => {
    return formFields
        .map((field, index) => ({
            field,
            originalIndex: index,
            fieldStep: field.step || 1
        }))
        .filter(({ fieldStep }) => fieldStep === stepNumber)
        .map(({ field, originalIndex }) => ({ field, originalIndex }));
};


export const getFieldsCount = (formFields: FormField[], stepNumber: number): number => {
    return getFieldsForStep(formFields, stepNumber).length;
};


export const removeFieldsForStep = (
    formFields: FormField[],
    stepNumber: number
): FormField[] => {
    const updatedFields = formFields.filter(field => (field.step || 1) !== stepNumber);

    return updatedFields.map(field => {
        if (field.step && field.step > stepNumber) {
            return { ...field, step: field.step - 1 };
        }
        return field;
    });
};

